export default __webpack_public_path__ + "static/media/CopyIconGreen.dfc741e4.svg";